import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
//import { FlexModule } from "@angular/flex-layout";
import { ReactiveFormsModule } from "@angular/forms";
import { MatAutocompleteModule } from "@angular/material/autocomplete";
import { MatButtonModule } from "@angular/material/button";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatIconModule } from "@angular/material/icon";
import { MatInputModule } from "@angular/material/input";
import { MatProgressSpinnerModule } from "@angular/material/progress-spinner";
import { MatSelectModule } from "@angular/material/select";
import { MatTableModule } from "@angular/material/table";

import { mdiMagnify } from "@mdi/js";

import { DffSideModule, PanelModule, SpinnerModule } from "@dffedb/ui";
import { SvgIconRegistry } from "@dffedb/util";
import { InstallationListeModule } from "@e-forsyning/common/installation";

import { InstallationerHuskelisteComponent } from "./installationer-huskeliste/installationer-huskeliste.component";
import { InstallationerRoutingModule } from "./installationer-routing.module";
import { InstallationerSoegComponent } from "./installationer-soeg/installationer-soeg.component";
import { InstallationerComponent } from "./installationer.component";

@NgModule({
    imports: [
        CommonModule,
        InstallationerRoutingModule,
        MatAutocompleteModule,
        MatButtonModule,
        MatFormFieldModule,
        MatIconModule,
        MatInputModule,
        MatSelectModule,
        MatProgressSpinnerModule,
        MatTableModule,
        DffSideModule,
        PanelModule,
        ReactiveFormsModule,
        SpinnerModule,
        InstallationListeModule
    ],
    declarations: [InstallationerComponent, InstallationerSoegComponent, InstallationerHuskelisteComponent],
    providers: []
})
export class EForsyningFeaturesInstallationerModule {
    constructor(svgIconRegistry: SvgIconRegistry) {
        svgIconRegistry.registerIcon(mdiMagnify, "search");
    }
}
